import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.AUTH_SERVER_PREFIX}/user`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getByDeviceId: (id: any) => `${RESOURCE_ENDPOINT}/device/${id}`,
    getByEmployeeId: (id: any) => `${RESOURCE_ENDPOINT}/employee/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    updateUserSetting: () => `${RESOURCE_ENDPOINT}/update-user-setting`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    forcePasswordChange: () => `${RESOURCE_ENDPOINT}/force-password-change`,
    getUserAndEmployeeInfo: () => `${RESOURCE_ENDPOINT}/user-and-employee-info`, // id = user id
    getUserDetailsForPrescription: () => `${RESOURCE_ENDPOINT}/getUserDetailsForPrescription`,
    updateMyProfile: () => `${RESOURCE_ENDPOINT}/my-profile`,
}

export default class UserApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    }

    public getByDeviceId = (id: any): AxiosPromise<any> => {
        const url = endpoints.getByDeviceId(id);
        return HttpService.get(url);
    }

      public getByEmployeeId = (id: any): AxiosPromise<any> => {
        const url = endpoints.getByEmployeeId(id);
        return HttpService.get(url);
    }

    public forcePasswordChange = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.forcePasswordChange();
        return HttpService.post(url, payload, params, headers);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public updateUserSettings = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updateUserSetting();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    }

    public getUserAndEmployeeInfo = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getUserAndEmployeeInfo();
        return HttpService.post(url, params, headers);
    }

    public getUserDetailsForPrescription = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getUserDetailsForPrescription();
        return HttpService.post(url, params, headers);
    }

    // Logged-in citizen updates own profile (auth_aq4nl4ag_applicant_profiles). Body: farmer_* / location fields + user_id
    public updateMyProfile = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updateMyProfile();
        return HttpService.put(url, payload, params, headers);
    }

}
